import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { Button } from '@mui/material'
import { useGetTexasCashCardQuery } from 'services/customers'
import { showFormModal } from 'state/ui'

const TexasCashCardCell = ({ params, customerData }) => {
  const dispatch = useDispatch()

  const id = params?.row?.id
  const { data: cashCardInfo } = useGetTexasCashCardQuery({ contactId: id }, { skip: !id })
  return cashCardInfo?.texasCashCardUrl ? (
    <Button
      variant="outlined"
      onClick={() => {
        dispatch(
          showFormModal({
            formModalName: 'create-cash-card',
            formModalProps: { customerData },
          }),
        )
      }}
    >
      View Cash Card
    </Button>
  ) : (
    ''
  )
}

TexasCashCardCell.propTypes = {
  params: PropTypes.object.isRequired,
  customerData: PropTypes.object.isRequired,
}

export default TexasCashCardCell
